// Import the required modules and types
import { Stack, Tooltip } from '@mui/material';

import React from 'react';

import moment from 'moment';

import { ReactComponent as DueIcon } from 'common/assets/images/Vector.svg';
import { displayDateFormat } from 'common/components/Datepicker/Datepicker';
import { dateFullYearFormat } from 'common/utils/utilFunctions';

import styles from './NotificationStatusIcon.module.scss';

const { iconDateRedColor, iconDateYellowColor } = styles;

interface Iprops {
	date: string | '';
}

// Define the component as a function
const NotificationStatusIcon: React.FC<any> = (props: Iprops) => {
	const { date } = props;
	// Calculate the next weekday and today
	const nextweekday = moment().add(1, 'week').format(displayDateFormat);
	const today = moment().format(displayDateFormat);

	// Determine the due chip and the overdue chip
	const duechip = date &&
		nextweekday > dateFullYearFormat(date) &&
		dateFullYearFormat(date) >= today && (
			<Tooltip title="Due">
				<DueIcon fill={iconDateYellowColor} width={16} height={16} />
			</Tooltip>
			// eslint-disable-next-line indent
		);
	const overDuechip = date && today > dateFullYearFormat(date) && (
		<Tooltip title="Overdue">
			<DueIcon fill={iconDateRedColor} width={16} height={16} />
		</Tooltip>
	);

	// Return the JSX element
	return (
		<Stack direction="row" className={styles['icon-date']}>
			{duechip}
			{overDuechip}
		</Stack>
	);
};

// Export the component
export default NotificationStatusIcon;
